import { LinkBracket } from '@components';

export const BackHomeButton: React.FC = () => (
  <div className='text-center'>
    <a
      href='/'
      className='inline-flex items-center gap-2 rounded-full border border-top-primary px-6 py-3 font-bold text-top-primary transition-opacity hover:opacity-75'
    >
      TOPへ戻る
      <LinkBracket className='mt-[1px]' />
    </a>
  </div>
);
